<template>
  <b-overlay :show="load" rounded="xl">
    <b-row>
      <b-col lg="12">
        <form-wizard
          color="#ce7b2c"
          :title="null"
          :subtitle="null"
          :finish-button-text="$t('site.finish')"
          :back-button-text="$t('site.back')"
          :next-button-text="$t('site.next')"
          class="steps-transparent mb-3"
          @on-complete="formSubmitted"
        >
          <b-card>
            <b-alert variant="danger" show v-if="resRrrors">
              <h4 class="alert-heading">{{ $t("site.error") }}</h4>
              <div
                class="alert-body"
                v-for="(rror, index) in resRrrors"
                :key="index"
              >
                <span>{{ index + 1 }} -</span> <span>{{ rror[0] }}</span>
              </div>
            </b-alert>

            <tab-content
              :title="$t('quran_programs.details')"
              :before-change="() => validateStep('details')"
              
            >
              <details-vue ref="details"  :new-item="newItem"/>
            </tab-content>
            <tab-content
              :title="$t('quran_programs.basic_information')"
              :before-change="() => validateStep('basic_information')"
               
            >
              <basic-vue ref="basic_information"  :new-item="newItem"/>
            </tab-content>
          </b-card>
        </form-wizard>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>
 
// import additionalInformation from "./components/additional_information.vue";
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";

import Controller from "@/Controllers/QuranProgramsController";
import basicVue from "./components/basic.vue";
import detailsVue from "./components/details.vue";

export default {
  components: {
    FormWizard,
    TabContent,
    basicVue,
    detailsVue,
  },
  props: ["newItem"],
  data() {
    return {
      newItemData:{},
      load: false,
      resRrrors: null,
    };
  },
  methods: {
    async validateStep(name) {
      const refToValidate = this.$refs[name];
      const returnData = await refToValidate.returnData();
      if (!returnData.valid) return false;
      // this.newItem = Object.assign(this.newItem, returnData.data);

      return true;
    },
    async formSubmitted() {
      this.load = true;
      let ret = await new Controller().From(this.newItem, "FormData");
      if (ret) {
        this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
        this.$parent.$parent.firstTab();
      }
      this.load = false;

      // if (res.status) this.$router.push({ name: "auth-login" });
    },
  },
};
</script>

<style>
</style>